// In your dispatcher/routes.ts
import { RouteObject } from "react-router-dom";
import MasterPage from "./components/landing/MasterPage";
import CreateSopPage from "./components/create/CreateSopPage";
import SopDetailsPage from "./components/details/SopDetailsPage";
import SOPCreationForm from "./components/bulkUpload/BulkUpload";

export interface MasterSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: MasterSetupRoute[];
}

export const masterSetupRoutes: MasterSetupRoute[] = [
  {
    path: "/service-orders/wx-master",
    element: <MasterPage />,
  },
  {
    path: "/service-orders/wx-master/create-sop",
    element: <CreateSopPage />,
  },
  {
    path: "/service-orders/wx-master/view-sop/:id",
    element: <CreateSopPage />, // Same stepper but read-only
  },
  {
    path: "/service-orders/wx-master/sop-details/:id", // Add this route
    element: <SopDetailsPage />,
  },
   {
    path: "/bulk-upload", // Add this route
    element: <SOPCreationForm />,
  },
  
];
